export default "<section>\n  <div class=\"pbi-container\">\n    <div #reportContainer class=\"report-body\"></div>\n  </div>\n</section>";